export default __webpack_public_path__ + "static/media/mochi-coin-circle-fill.93b1c4e1.svg";